import { useState } from "react";

const faqs = [
  {
    q: "吃瓜视频在线需要安装任何软件或插件吗？",
    a: "完全不需要。本站视频采用网页直连方式播放，无需下载客户端、无需安装任何插件，打开页面点击播放即可，真正做到即点即看。",
  },
  {
    q: "手机和电脑上都能正常观看吗？",
    a: "可以的。网站针对手机端做了全面适配，竖屏、横屏都能流畅观看，同时完美兼容电脑、平板等设备，随时随地想看就看。",
  },
  {
    q: "视频是免费的吗？内容多久更新一次？",
    a: "本站所有视频均免费观看，热门吃瓜内容每日实时更新，确保你能第一时间看到最新的话题和热门视频。",
  },
  {
    q: "都有哪些类型的吃瓜视频？",
    a: "目前设有娱乐八卦、社会热点、明星现场、生活趣事、萌宠日常、街头采访六大分类，覆盖大家最常看的吃瓜内容，并持续扩展更多栏目。",
  },
  {
    q: "播放卡顿或加载慢怎么办？",
    a: "本站视频采用极速缓冲技术，正常情况下可实现秒开。如果遇到卡顿，建议切换网络环境或刷新页面重试，多线路播放也会让体验更流畅。",
  },
  {
    q: "想看的视频没找到，或者有好的内容想推荐怎么办？",
    a: "欢迎通过页面底部的联系表单告诉我们，也可以直接留言推荐想看的内容，我们会认真整理并在后续更新中优先呈现。",
  },
];

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="text-center">
          <p className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
            <i className="ri-question-line"></i>
            常见问题
          </p>
          <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-3xl">
            关于吃瓜视频在线，你想知道的都在这里
          </h2>
        </div>

        <div className="mt-8 flex flex-col gap-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.q}
                className="overflow-hidden rounded-lg bg-background-100 ring-1 ring-background-200"
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : i)}
                  className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left md:px-5"
                >
                  <span className="text-sm font-medium text-foreground-950 md:text-base">
                    {f.q}
                  </span>
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                    <i className={`ri-arrow-down-s-line ${isOpen ? "rotate-180" : ""} transition-transform`}></i>
                  </span>
                </button>
                {isOpen && (
                  <p className="px-4 pb-4 text-sm leading-relaxed text-foreground-700 md:px-5">
                    {f.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}